import { useMutation, useQueryClient } from '@tanstack/react-query';

import { NoteCreateFormValues } from '../../../../../types';
import { handleError, handleSuccess } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../../logic';
import { ApiErrorResponse } from '../../../../types';
import { APPLICATION_BASE_PATH } from '../../constants/applicationBasePath';
import { postCreateApplicationNote } from '../../requests/postCreateApplicationNote';

export const useCreateApplicationNote = (
  uuid: string,
  definitionName: string,
) => {
  const queryClient = useQueryClient();
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: createNote, ...rest } = useMutation({
    mutationFn: (formValues: NoteCreateFormValues) =>
      postCreateApplicationNote(
        constructPost,
        uuid,
        definitionName,
        formValues,
      ),
    onSuccess: () => {
      handleSuccess('Message created.');
      queryClient.invalidateQueries({
        queryKey: [APPLICATION_BASE_PATH, uuid, 'messages'],
      });
    },
    onError: (error: ApiErrorResponse) =>
      handleError(
        getApiErrorMessage(
          error,
          'An unknown error occurred while creating the note.',
        ),
      ),
  });

  return { createNote, ...rest };
};
